// extracted by mini-css-extract-plugin
export default {"table_container":"RacketSkeleton_table_container__E1r2+","skeleton_item":"RacketSkeleton_skeleton_item__MS1gF","shimmer":"RacketSkeleton_shimmer__ltkrD"};